import { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import axios from 'axios';
import { Button, Divider, Link, ListItemText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { setTimeout } from 'timers';
import { IState } from '../interface';
import { useSelector } from 'react-redux';
const QRCode = require('qrcode.react');
  

interface IAfiliados {
    id: string;
    nombre: string;
    apellidos: string;
    email: string;
    celular: string;
    dateCreated: string;
}

const textShadow = '0px 4px 10px rgba(0, 0, 0, 0.25)';

const useStyles = makeStyles({
  card: {
    textShadow: textShadow,
  },
  textShadow: {
    textShadow: textShadow,
    color: '#e07510',
    textAlign: 'center'
  }
});


const inpStyle = {
  width: '85%',
  fontSize: '1.3em',
  height: '30px',
  color: 'blue',
  border: 'none',
  marginRight: '10px',
}

export const Afiliados = () => {
    const { idUser: user } = useSelector((state: IState) => state.user.user);
    const [ afiliados, setAfiliados ] = useState<IAfiliados[]>([])
    const [ copiado, setCopiado ] = useState({value: "", copied: false});
    const classes = useStyles();

    const getAfiliados = async (id: string) => {
        const res = await axios.get('/api/afiliados/' + id)
        const da = await res.data
        setAfiliados(da)
    }

    useEffect(() => {
      setCopiado({ ...copiado, value: `https://network.finanservs.com?Ref=${ user }` })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      getAfiliados(user)
    }, [user])

    const clearMsg = () => {
      setCopiado({ ...copiado, copied: false})
    } 

    const onClickCopy = () => {
      setCopiado({ ...copiado, copied: true})
      setTimeout( () => { clearMsg() }, 300)
    }

    return (
        <Container sx={{ pt: 8 }} >
          <Typography className={classes.textShadow} variant="h5">
              Link de Referidos: 
          </Typography>
          <Box component="form" noValidate sx={{ mt: 1 }}>
              <Grid container direction="column" alignItems="center">
                  <div style={{ textAlign: 'center' }}>

                    <input style={inpStyle}  value={`https://network.finanservs.com`}/>

                    <CopyToClipboard text={copiado.value}
                      onCopy={ () => onClickCopy() }>
                      <ContentCopyOutlinedIcon style={{ color:"green", width:"20px" }} />
                    </CopyToClipboard>

                    {copiado.copied ? <span style={{ color: 'red', fontSize: '9px' }}>Copiado...</span> : null}
                  </div>
              </Grid>
          </Box>
    
          <Grid container direction="column" alignItems="center">
            <Button 
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
            >
            <Link href={`https://finanservs.com?idRef=${ user }`} variant="h5" underline="hover" target="_blank" rel="noreferrer" color={"white"}>
              {'Pide tu préstamo aquí!'}
            </Link>
            </Button>
          </Grid>
          <Divider sx={{ pb: 0 }} />
          <Typography className={classes.textShadow} gutterBottom sx={{ pt: 2 }} variant="h4" component="h2">
              { afiliados.length ? "Mis Referidos" : "Sin Referidos" }
          </Typography>
          {afiliados.length > 0 ?
            (
            <Grid container spacing={2}>
              {afiliados.map((afil) => (
                <Grid item key={afil.id} xs={6} sm={6} md={4}>
                  <Card className={classes.card}
                    sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography gutterBottom variant="h5" component="h2">
                        {afil.nombre + ' ' + afil.apellidos}
                      </Typography>
                      <Typography>
                        <ListItemText primary={`Email: ${afil.email}`} />
                        <ListItemText primary={`Celular: ${afil.celular}`} />
                        <ListItemText primary={`Creado: ${afil.dateCreated}`} />
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
            ): ""
          }
          <br />
          <Grid container direction="column" alignItems="center">
            <Grid item xs={12} sm={12} md={12} spacing={2}>
              <Card
                sx={{ height: '100%', flexDirection: 'column' }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography style={{ textAlign: 'center' }}>
                    Comparta su código QR.
                  </Typography>
                  <Typography sx={{ pt: 4 }} textAlign="center">                  
                    <QRCode value={ `https://network.finanservs.com?Ref=${user ? user: "1"}` } />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>   
          </Grid>
        </Container>
    )
}

export default Afiliados;